import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes";

// export const getUserList = async (page, pageSize,search) => {
//   const response = await apiService.get(apiRoutes.userList, page,pageSize);
//   return response.data;
// };

export const getUserList = async ({ page, limit, search }) => {
  const response = await apiService.post(apiRoutes.userList, {
    page,
    limit,
    search,
  });
  return response.data;
};

export const destroyUser = async (id) => {
  const response = await apiService.post(apiRoutes.userDestroy, {
    params: { id },
  });
  return response.data;
};

// export const createUser = async (user) => {
//   const response = await apiService.post(apiRoutes.userCreate, user);
//   return response.data;
// };

export const createUser = async (userFormData) => {
  const response = await apiService.post(apiRoutes.userCreate, userFormData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const UpdateUserProfile = async (userId, userFormData) => {
  const response = await apiService.post(
    `${apiRoutes.UpdateUserProfile}/${userId}`, 
    userFormData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

export const fileUpload = async (userFormData) => {
  const response = await apiService.post(apiRoutes.fileUpload, userFormData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const updateUser = async (user) => {
  const response = await apiService.post(apiRoutes.userUpdate, user);
  return response.data;
};

export const viewUser = async (userId) => {
  const response = await apiService.post(apiRoutes.viewUser, userId);
  return response.data;
};

export const getProfile = async () => {
  const response = await apiService.get(apiRoutes.adminProfile);
  return response.data;
};


export const updateProfile = async (profile) => {
  const response = await apiService.post(apiRoutes.adminUpdateProfile, profile);
  return response.data;
};

export const passwordChange = async (oldPassword,newPassword,confirmPassword) => {
  const response = await apiService.post(apiRoutes.adminPasswordChange, {oldPassword,newPassword,confirmPassword});
  return response.data;
};

export const userFollowerList = async (payload) => {
  const response = await apiService.post(apiRoutes.userFollowerList, payload);
  return response.data;
};

export const userFollowingList = async (payload) => {
  const response = await apiService.post(apiRoutes.userFollowingList, payload);
  return response.data;
};
